/**
 * Parse Customer Details from GraphQL to frontend format
 */
export const parseCustomerDetailsFromGraphQL = (customerDetails) => {
  if (!customerDetails) return { profile: null, company: null };

  // Parse profile data
  const profile = {
    id: customerDetails.id,
    cognitoUserId: customerDetails.cognitoUserId,
    userName: customerDetails.userName,
    email: customerDetails.email,
    firstName: customerDetails.firstName,
    lastName: customerDetails.lastName,
    status: customerDetails.status?.statusName || null,
    customerId: customerDetails.customer?.id || null,
    stripeCustomerId: customerDetails.stripeCustomerId || null
  };

  // Parse company data - only if customer object exists AND has a valid company name
  const company = customerDetails.customer && customerDetails.customer.companyName ? {
    id: customerDetails.customer?.id,  // use customer id as company id
    name: customerDetails.customer.companyName,
    owner: `${customerDetails?.firstName} ${customerDetails?.lastName}`.trim(),
    phone: customerDetails.customer.phone,
    email: customerDetails.email, // User email
    website: customerDetails.customer.website,
    address: customerDetails.customer.address1,
    address2: customerDetails.customer.address2,
    city: customerDetails.customer.city,
    state: customerDetails.customer.state,
    zip: customerDetails.customer.zip,
    industry: customerDetails.customer.industry?.typeName || null,
    customerType: customerDetails.customer.customerType?.typeName || null,
    type: customerDetails.customer.customerType?.typeName || null, // Alias for backwards compatibility
    numberOfEmployees: customerDetails.customer.numberofEmployee?.typeName || null,
    testCustomer: customerDetails.customer.testCustomer,
    localPlus: customerDetails.customer.localPlus,
    createdDate: customerDetails.customer.createdDate
  } : null;

  return { profile, company };
};

